// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string, object, oneOfType } from 'prop-types'

const LookupWrapper = ({ lookup }) => (
  lookup
    ? (
      <div className={'lookup'}>
        {lookup}
      </div>
    ) : null
)

LookupWrapper.propTypes = {
  lookup: oneOfType([
    string,
    object,
  ]),
}

export default LookupWrapper
